module.exports = __webpack_public_path__ + "static/media/logo-horizontal.51db3dbd.svg";